export const deviceBreakpoints = {
  mobile: 768,
  laptop: 1024,
  desktopSmall: 1280,
  desktopMedium: 1440,
};

export const deviceTypes = {
  mobile: 'mobile',
  laptop: 'laptop',
  desktopSmall: 'desktop-sm',
  desktopMedium: 'desktop-m',
  desktopLarge: 'desktop-l',
};

export const sectionIds = {
  intro: 'intro-section',
  about: 'about-section',
  download: 'download-section',
};
